<div class="title-row flex">
  <div
    class="title"
    data-testid="title"
  >
    {{ data.state.label }}
  </div>
  <button
    class="copy-node-text"
    payee-mini-icon-button
    color="white"
    title="Címke másolása"
    data-testid="copy-node-text"
    (click)="copyNodeText($event)"
    (mousedown)="$event.stopPropagation()"
  >
    <mat-icon>content_copy</mat-icon>
  </button>
</div>
<div class="meta-info">
  <span>{{ data.state.class_name }}</span>
</div>
@if (data.state.is_refundable) {
  <div
    class="refundable-hint"
    title="Ebben az állapotban az ügy visszatéríthető."
    data-testid="refundable-hint"
  >
    <mat-icon>payments</mat-icon>
    <span>Visszatéríthető</span>
  </div>
}
@if (data.state.expected_transition; as expectedTransition) {
  <div
    class="expected-transition-hint"
    data-testid="expected-transition-hint"
    [title]="
      'Várható esemény: ' +
      expectedTransition.label +
      ' · ' +
      expectedTransitionDuration(expectedTransition.at) +
      ' (@ ' +
      expectedTransition.at +
      ')'
    "
  >
    <mat-icon>schedule</mat-icon>
    <span>{{ expectedTransition.label }} · {{ expectedTransitionDuration(expectedTransition.at) }}</span>
  </div>
}
<div class="flex connections">
  <div class="flex column inputs">
    @for (input of data.inputs | keyvalue; track input.key) {
      <div
        class="input"
        [attr.data-testid]="'input-' + input.key"
      >
        <div
          class="input-socket"
          refComponent
          data-testid="input-socket"
          [data]="{
            type: 'socket',
            side: 'input',
            key: input.key,
            nodeId: data.id,
            payload: input.value?.socket,
            seed: seed,
          }"
          [emit]="emit"
        ></div>
      </div>
    }
  </div>
  <div class="flex column outputs">
    @for (output of data.outputs | keyvalue; track output.key) {
      <div
        class="output"
        [attr.data-testid]="'output-' + output.key"
      >
        <div
          class="output-socket"
          refComponent
          data-testid="output-socket"
          [data]="{
            type: 'socket',
            side: 'output',
            key: output.key,
            nodeId: data.id,
            payload: output.value?.socket,
            seed: seed,
          }"
          [emit]="emit"
        ></div>
      </div>
    }
  </div>
</div>
